import Icon from './components/Icon';
export * from './icons';
export default Icon;